import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";

export default function PageShell({ children }) {
  return (
    <main className="relative bg-background text-foreground min-h-screen">
      <Nav />
      <div className="pt-20">{children}</div>
      <Footer />
    </main>
  );
}
